<template>
  <FormSection :title="$t('APP.RELEASES.TITLE')" class="app-releases">
    <div class="small-12 columns">
      <CreateReleaseButton
        v-if="!hasUncommittedRelease"
        :disabled="canCreateNewRelease"
      />

      <Transition name="el-fade-in-linear">
        <NewRelease v-if="!fetchingData && hasUncommittedRelease" />
      </Transition>

      <hr v-if="hasUncommittedRelease" class="divider" />

      <UsedFeaturesAndLibraries
        v-if="app.featuresAndLibraries"
        v-bind="app.featuresAndLibraries"
        class="app-releases__alert raised"
      />

      <CardApiError v-if="apiError" @retry="getReleases" />

      <Card v-else :is-loading="fetchingData" no-padding>
        <AppReleasesTable :data="releases || []" />
      </Card>
    </div>
  </FormSection>
</template>

<script>
import Card from '@@/common/Card';
import CardApiError from '@@/common/CardApiError';
import FormSection from '@@/common/layout/FormSection';
import AppReleasesTable from './AppReleasesTable';
import NewRelease from './NewRelease';
import CreateReleaseButton from './CreateReleaseButton';
import appState from '@/mixins/appState';
import packageName from '@/mixins/packageName';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import form from '@/mixins/form';
import { mapActions, mapGetters } from 'vuex';
import {
  RELEASES,
  APP_DETAILS,
  UNCOMMITTED_RELEASE,
  GROUP_RELEASE,
} from '@/store/types';
import UsedFeaturesAndLibraries from '../common/UsedFeaturesAndLibraries';

export default {
  name: 'AppReleases',
  components: {
    CardApiError,
    AppReleasesTable,
    Card,
    NewRelease,
    CreateReleaseButton,
    FormSection,
    UsedFeaturesAndLibraries,
  },
  mixins: [appState, packageName, packageNameWatch, form],

  data() {
    return {
      fetchingData: false,
      apiError: false,
    };
  },

  computed: {
    ...mapGetters({
      app: APP_DETAILS,
      releases: RELEASES,
      alphaGroups: RELEASES,
      betaGroups: RELEASES,
      uncommittedRelease: UNCOMMITTED_RELEASE,
    }),
    hasUncommittedRelease() {
      return Boolean(this.uncommittedRelease?.token);
    },
    canChangeAutoPublish() {
      return this.app.publish_state === 'N';
    },
    isRejected() {
      return this.app.published === 'J';
    },
    canCreateNewRelease() {
      return this.fetchingData || this.isRejected;
    },
  },

  created() {
    this.getInfo();
  },

  methods: {
    ...mapActions({
      fetchCommittedReleasesList: RELEASES,
      fetchUncommitedRelease: UNCOMMITTED_RELEASE,
      getGroupRelease: GROUP_RELEASE,
    }),
    getInfo() {
      return this.getReleases();
    },
    getReleases() {
      this.fetchingData = true;
      this.apiError = false;

      return Promise.all([
        this.fetchCommittedReleasesList(this.packageName),
        this.fetchUncommitedRelease(this.packageName),
        this.getGroupRelease(this.packageName),
      ])
        .catch(() => {
          this.apiError = true;
        })
        .finally(() => {
          this.fetchingData = false;
        });
    },
  },
};
</script>

<style lang="scss">
.app-releases {
  &__alert {
    margin-top: $global-margin;
  }
}
</style>
